module.exports = __webpack_public_path__ + "img/ics_o_whatsapp-background.8e5d7b92.svg";